import React, { FunctionComponent } from "react";
import { ButtonProps } from "./ButtonShared";

const ButtonOutlineDanger = React.forwardRef(
    (
        {
            Base,
            className,
            ...props
        }: {
            Base: FunctionComponent<
                ButtonProps & {
                    buttonClassName?: string;
                    textClassName?: string;
                    iconClassName?: string;
                } & React.ButtonHTMLAttributes<HTMLButtonElement>
            >;
        } & ButtonProps &
            React.ButtonHTMLAttributes<HTMLButtonElement> &
            React.RefAttributes<HTMLButtonElement>,
        forwardedRef: React.Ref<HTMLButtonElement>
    ) => {
        return (
            <Base
                ref={forwardedRef}
                className={`bg-white hover:bg-secondary active:bg-tertiary  ${
                    props.active
                        ? " border-brand border-2"
                        : "border border-danger"
                } ${className}`}
                textClassName="text-primary"
                iconClassName="text-danger"
                {...props}
            />
        );
    }
);

export default ButtonOutlineDanger;
